import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=08735633&scoped=true&"
import script from "./noticeBar.vue?vue&type=script&lang=ts&"
export * from "./noticeBar.vue?vue&type=script&lang=ts&"
import style0 from "./noticeBar.vue?vue&type=style&index=0&id=08735633&lang=less&scoped=true&"
import style1 from "./noticeBar.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08735633",
  null
  
)

export default component.exports